// extracted by mini-css-extract-plugin
module.exports = {"button1":"buttonNextGame_button1__19dtV","body":"buttonNextGame_body__2uOO_"};